import { render, staticRenderFns } from "./OtimizadorSettings.vue?vue&type=template&id=28f425fa"
import script from "./OtimizadorSettings.vue?vue&type=script&lang=js"
export * from "./OtimizadorSettings.vue?vue&type=script&lang=js"
import style0 from "./OtimizadorSettings.vue?vue&type=style&index=0&id=28f425fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports